import { render } from "./EditManual.vue?vue&type=template&id=70e205f0&scoped=true"
import script from "./EditManual.vue?vue&type=script&lang=js"
export * from "./EditManual.vue?vue&type=script&lang=js"

import "./EditManual.vue?vue&type=style&index=0&id=70e205f0&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e205f0"]])

export default __exports__